import { FunctionComponent, ReactNode } from "react";

type SliderProps = {
  children?: ReactNode;
};

const Slider: FunctionComponent<SliderProps> = ({ children }) => {
  return <div className="relative w-full">{children}</div>;
};

export default Slider;
